import React from 'react';
import {Modal, Tab, Tabs,Grid,} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import Alert from '../../../Helper/SimpleAlert/alert';
import EditProfilePage from './editProfilePages/editProfile';
import ChangePassword from './editProfilePages/changePassword';
import ChangeLocation from './editProfilePages/changeLocation';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

const styles = theme => ({
    textField: {
        width: 220,
    },
    inputText: {
        fontSize: '20px',
       // width: 120
    },
    textLabel: {
        fontSize: '18px',
        fontWeight: 400
    },
    submitButton: {
        width: '100%',
        fontSize: '18px',
        marginTop: '15px',
        justifyContent: 'center'
    },
});

class EditProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updateProfile: 0,
            showAlert:false,
            alertMessage:""
        };
    }

    onCategoryClick = (e, value) => {
        this.setState({updateProfile: value});
    };

    updateState= (state,text) => {
        this.setState({
            [state]:text
        });
        this.props.onUpdate();
    };

    toggleAlert = () => {
        this.setState({
            showAlert:!this.state.showAlert
        });
    };
    render() {
        let {classes, handleOpen, user} = this.props;
        let { updateProfile, showAlert, alertMessage} = this.state;
        return (
            <div>
                {showAlert && <Alert showSuccess={true} showError={false} onClose={this.toggleAlert} Msg={alertMessage} />}
                <Modal
                    open={true}
                    onClose={handleOpen}
                >
                    <div className="editModal">
                        {/*<IconButton color="inherit" onClick={this.handleClose}aria-label="Close">*/}
                            {/*<CloseIcon />*/}
                        {/*</IconButton>*/}
                        <Grid container spacing={24}>
                            <Grid item sm={12} xs={12} md={12}>
                               <div style={{display:'flex'}}>
                                   <div>
                                       <Tabs
                                  className="tabsCss"
                                  value={updateProfile}
                                  onChange={this.onCategoryClick}
                                  indicatorColor="primary"
                                  textColor="primary"
                                  scrollable={window.innerWidth <767?true:false}
                                  scrollButtons={window.innerWidth <767?"on":"off"}
                                >
                                    <Tab className="tab-label" label='Update Profile'/>
                                    <Tab className="tab-label" label='Change Password'/>
                                    <Tab className="tab-label" label='Change My Location'/>
                                        </Tabs>
                                   </div>
                                    <div>
                                        <IconButton color="inherit" onClick={handleOpen} aria-label="Close" className="close-btn-edit-modal" >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                               </div>
                            </Grid>
                            <Grid item sm={12} xs={12} md={12}>
                                {
                                    updateProfile === 0
                                        ?
                                            <EditProfilePage
                                                classes={classes}
                                                user={user}
                                                updateState={this.updateState}
                                                toggleAlert={this.toggleAlert}
                                                showAlert={this.props.showAlert}

                                            />
                                        :
                                        updateProfile === 1
                                            ?
                                            <ChangePassword
                                                classes={classes}
                                                user={user}
                                                toggleAlert={this.toggleAlert}
                                                updateState={this.updateState}
                                                handleOpen={handleOpen}
                                                showAlert={this.props.showAlert}
                                            />
                                            :
                                            <ChangeLocation
                                                classes={classes}
                                                user={user}
                                                toggleAlert={this.toggleAlert}
                                                updateState={this.updateState}
                                                handleOpen={handleOpen}
                                                showAlert={this.props.showAlert}
                                            />
                                }
                            </Grid>
                        </Grid>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default withStyles(styles)(EditProfile);
